<script setup>
import { ref, onMounted, onUnmounted, watch, shallowRef } from 'vue'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

const props = defineProps({
  data: {
    type: Object,
    required: false,
    default: () => ({
      labels: ['Aug', 'Sep', 'Nov', 'Dec', 'Jan'],
      datasets: [
        {
          label: 'Conversations',
          data: [10, 20, 40, 15, 120, 25],
          borderColor: '#4285F4',
          backgroundColor: 'rgba(66, 133, 244, 0.1)',
          tension: 0.4,
          fill: true,
          pointBackgroundColor: '#4285F4',
          pointBorderWidth: 2,
          pointRadius: 4,
          pointHoverRadius: 6
        }
      ]
    })
  }
})

const chartCanvas = ref(null)
const chartInstance = shallowRef(null)

const renderChart = () => {
    if (chartInstance.value) {
        chartInstance.value.destroy()
        chartInstance.value = null
    }
    
    if (chartCanvas.value) {
        chartInstance.value = new Chart(chartCanvas.value, {
            type: 'line',
            data: props.data,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true,
                        grid: {
                            color: 'rgba(0, 0, 0, 0.05)',
                             borderDash: [5, 5]
                        },
                         ticks: {
                            padding: 10,
                            color: '#9ca3af'
                        },
                         border: {
                             display: false
                         }
                    },
                    x: {
                        grid: {
                            display: false
                        },
                        ticks: {
                             padding: 10,
                             color: '#9ca3af'
                        },
                         border: {
                             display: false
                         }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        backgroundColor: '#1f2937',
                        padding: 12,
                        cornerRadius: 8,
                        titleFont: { size: 14, weight: 'bold' },
                        bodyFont: { size: 13 },
                        displayColors: false,
                        callbacks: {
                            label: function(context) {
                                return ` ${context.parsed.y} convos`;
                            }
                        }
                    }
                },
                interaction: {
                    mode: 'index',
                    intersect: false
                }
            }
        })
    }
}

watch(() => props.data, () => {
    renderChart()
}, { deep: true })

onMounted(() => {
    renderChart()
})

onUnmounted(() => {
    if (chartInstance.value) {
        chartInstance.value.destroy()
        chartInstance.value = null
    }
})
</script>

<template>
  <div class="chart-wrapper">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<style scoped>
.chart-wrapper {
  height: 100%;
  width: 100%;
  min-height: 250px;
}

.card-body {
  padding: 0 !important;
}
</style>
